<template>
	<div>
		<b-col cols="12">
        <b-row class="mb-4 mx-3 justify-content-end">
          <b-col cols="auto" class="px-1">
          	<b-button class="float-right" variant="outline-secondary" @click="$refs.filter_drawer.showDrawer()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#73839C"
                  d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
              </svg>
              Filters
            </b-button>
          </b-col>
      </b-row>
			<!-- <b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="6" class="d-md-flex">
					<base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search">
					</base-input>
				</b-col>
				<b-col cols="12" md="3">
					<b-button class="float-right" variant="outline-secondary" @click="$refs.filter_drawer.showDrawer()">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
							<path fill="#73839C"
								d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
						</svg>
						Filters
					</b-button>
				</b-col>
			</b-row> -->
			<div class="table-listings">
				<el-table ref="multipleTable" :data="queriedData" style="width: 100%" empty-text="No Data"
					@selection-change="selectionChange" highlight-current-row>
					<el-table-column width="20"></el-table-column>

					<el-table-column width="200" prop="prod_id">
						<template #header>
							<div class="d-flex flex-column">
								<div>Transaction Type</div>
								<div>Transaction Date</div>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="font-weight-bold">
								<p class="top-line text-primary cursor-pointer" @click="showDetail(scope.row)" v-if="scope.row.cbh_transaction_type == 'USED'">{{ scope.row.cbh_transaction_type }}</p>
								<p class="top-line" v-else>{{ scope.row.cbh_transaction_type }}</p>
							</div>
							<div>{{ scope.row.cbh_created_date | dateFormatString }}</div>
						</template>
					</el-table-column>

					<el-table-column label="Description" min-width="400" width="auto">
						<template slot-scope="scope">
							<p class="mb-0">{{ scope.row.cbh_description }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Debit" min-width="100" width="auto">
						<template slot-scope="scope">
							<p class="mb-0" v-if="(scope.row.cbh_credit_type == 'POINTS')">{{
								(['TRANSFER', 'USED'].indexOf(scope.row.cbh_transaction_type) !== -1) ? (scope.row.cbh_transaction_qty *
									-1) : "-" }}</p>
							<p class="mb-0" v-if="(scope.row.cbh_credit_type != 'POINTS')">{{
								(['TRANSFER', 'USED'].indexOf(scope.row.cbh_transaction_type) !== -1) ?
								parseInt(scope.row.cbh_transaction_qty * -1) : "-" }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Credit" min-width="100" width="auto">
						<template slot-scope="scope">
							<p class="mb-0" v-if="(scope.row.cbh_credit_type == 'POINTS')">{{
								(['BRING_FORWARD', 'TOPUP', 'RECEIVED'].indexOf(scope.row.cbh_transaction_type) !== -1) ?
								scope.row.cbh_transaction_qty : "-" }}</p>
							<p class="mb-0" v-if="(scope.row.cbh_credit_type != 'POINTS')">{{
								(['BRING_FORWARD', 'TOPUP', 'RECEIVED'].indexOf(scope.row.cbh_transaction_type) !== -1) ?
								parseInt(scope.row.cbh_transaction_qty) : "-" }}</p>
						</template>
					</el-table-column>

					<el-table-column min-width="100" width="auto">
						<template #header>
							<span class="w-100">Last <br /> Balance</span>
						</template>
						<template slot-scope="scope">
							<p class="mb-0" v-if="(scope.row.cbh_credit_type == 'POINTS')">{{ scope.row.cbh_new_balance | moneyFormatter
							}}</p>
							<p class="mb-0" v-if="(scope.row.cbh_credit_type != 'POINTS')">{{ parseInt(scope.row.cbh_new_balance) }}</p>
						</template>
					</el-table-column>

					<el-table-column width="130" class-name="text-center">
						<template #header>
							<span class="text-center w-100">By User</span>
						</template>
						<template slot-scope="scope">
							<el-tooltip v-if="scope.row.created_by_detail" placement="bottom" effect="dark">
								<div slot="content">
									Name: {{ scope.row.created_by_detail.name }}
								</div>
								<b-avatar size="32px" :text="formatInitials(scope.row.created_by_detail.name)"></b-avatar>
							</el-tooltip>
							<div v-else>
								<span style="font-size: 1.5rem">-</span>
							</div>
						</template>
					</el-table-column>


				</el-table>
			</div>
		</b-col>
		<div class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap card-footer">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select>

			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<!-- <CreditBalanceDetailDrawer ref="credit_balance_drawer" :detail="{}"></CreditBalanceDetailDrawer> -->
		<FilterDrawer ref="filter_drawer" @filter_submit="filterSubmit($event)" />
		<CreditReportDetailDrawer ref="credit_report_drawer" @show_preview="showPreview($event)"/>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</div>
</template>
<script>
// import CreditBalanceDetailDrawer from '@/views/Setup/CreditBalance/Drawers/CreditBalanceDetailDrawer'
import FilterDrawer from '@/views/CreditReports/CreditBalance/Drawers/FilterDrawer'
import CreditReportDetailDrawer from '@/views/CreditReports/CreditBalance/Drawers/Details/CreditReportDetailDrawer'
import PreviewModal  from '@/components/Modal/PreviewModal'
import { Table, TableColumn, Select, Option, Button, Tooltip } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCreditReportStore } from '@/stores/creditReportStore'

export default {
	props: {
		tableData: Array
	},
	mixins: [clientPaginationMixin, notifyFunctionMixin, helperFunctionMixin],
	components: {
		PreviewModal,
		BasePagination,
		CreditReportDetailDrawer,
		FilterDrawer,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Tooltip.name]: Tooltip,
	},
	data() {
		return {
			propsToSearch: ['cbh_id'],
			isFixed: true,
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			pagination: {
				perPage: 10
			},
			detail_item: {}
		}
	},
	watch: {
		tableData(newVal) {
			if (newVal) {
			}
		}
	},
	mounted() {
		this.setFixed();
		window.addEventListener('resize', this.setFixed);

		this.debouncedHandler = debounce(() => {
		}, 500);
	},
	methods: {
		...mapActions(useCreditReportStore, ['getCreditReportSummary']),
		filterSubmit(event) {
			this.$emit('filter_submit', event)
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		setFixed() {
			this.isFixed = window.innerWidth > 768;
		},
		async showDetail(item) {
			if (item.cbh_transaction_type == 'USED') {
				await this.getCreditReportSummary({ credit_report_id: item.cbh_crp_id });
				this.$refs.credit_report_drawer.showDrawer();
			}
		},
		showPreview(event){
			this.$refs.preview_modal.preview(event);
		}
	}
}
</script>